import { CannedQuestionName } from '../../api/models/survey';
import { CANNED_QUESTION_NAME_TO_QUESTIONS_COLLECTION_NAME } from '../../models/survey';
import { getQuestionsCollection } from '../../selectors/survey/pureSelectors';
import { CheckoutState } from '../../state';

export const hasTaxQuestions = (state: CheckoutState) => {
    const nameTaxReceiptKey =
        CANNED_QUESTION_NAME_TO_QUESTIONS_COLLECTION_NAME[
            CannedQuestionName.nameTaxReceipt
        ];

    return nameTaxReceiptKey in getQuestionsCollection(state);
};
